function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Space, Button, Skeleton, message, Drawer, Tag, Modal, notification } from 'antd';
import { UmbrellaFill, Building, PieChartFill, XSquareFill, TrashFill, PencilSquare } from 'react-bootstrap-icons';
import NewCompany from "../components/forms/NewCompany";
import NewInsurance from "../components/forms/NewInsurance";
import Common from "../components/includes/Common";
import EditCompany from "../components/forms/EditCompany";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Companies = function Companies() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    newCompanyVisible = _useState2[0],
    setNewCompanyVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    newInsuranceVisible = _useState4[0],
    setNewInsuranceVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    reportsDrawerVisible = _useState6[0],
    setReportsDrawerVisible = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    cList = _useState8[0],
    setcList = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState0[0],
    setIsDataLoading = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    dataChanged = _useState10[0],
    setDataChanged = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedCompany = _useState12[0],
    setSelectedCompany = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showEdit = _useState14[0],
    setShowEdit = _useState14[1];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getcompanylist/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setcList(response.data.companyList);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 11,
          md: 12,
          children: [/*#__PURE__*/_jsx(Space, {
            direction: "horizontal",
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: function onClick() {
                setNewCompanyVisible(true);
              },
              icon: /*#__PURE__*/_jsx(Building, {}),
              children: /*#__PURE__*/_jsx("b", {
                children: "AJOUTER UNE ENTREPRISE"
              })
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
            className: "cool-radius white-bg",
            children: [/*#__PURE__*/_jsxs(Table, {
              responsive: true,
              bordered: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Ref"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Type"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Tel"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Adresse"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Couverture"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Taux commercial"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Taxe/Retenue"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Assurance"
                  }), /*#__PURE__*/_jsx("th", {})]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: cList.map(function (ic) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsxs("td", {
                      children: ["E", ic.id]
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.type == 0 ? /*#__PURE__*/_jsx(Tag, {
                        color: "#BB6A4E",
                        children: "SOCIETE"
                      }) : /*#__PURE__*/_jsx(Tag, {
                        color: "#39896F",
                        children: "ASSURANCE"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.label
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.telephone
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.address
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [ic.rate, " %"]
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [ic.commercial_rate, " %"]
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [ic.tax_rate, " %"]
                    }), /*#__PURE__*/_jsx("td", {
                      children: ic.company && /*#__PURE__*/_jsx("b", {
                        children: ic.company.label
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            setSelectedCompany(ic);
                            setShowEdit(true);
                          },
                          children: /*#__PURE__*/_jsx(PencilSquare, {
                            size: 24
                          })
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "link",
                          onClick: function onClick() {
                            setSelectedCompany(ic);
                            confirm({
                              title: /*#__PURE__*/_jsx("b", {
                                children: "Confirmez-vous ?"
                              }),
                              content: /*#__PURE__*/_jsxs("p", {
                                children: ["La suppression de la soci\xE9t\xE9 ", ic.label, " avec toutes ses donn\xE9es ?"]
                              }),
                              onOk: function onOk() {
                                axios.post(Common.baseApiUrl + "deletecompany", {
                                  user_id: Common.currentUser.id,
                                  id: ic.id
                                }).then(function (response) {
                                  if (response.data.status == 200) {
                                    notification.success({
                                      message: "Ok!",
                                      description: response.data.message
                                    });
                                  } else {
                                    notification.error({
                                      message: "Erreur!",
                                      description: response.data.message
                                    });
                                  }
                                })["catch"](function (error) {
                                  notification.error({
                                    message: "Erreur!",
                                    description: "Une erreur est survenue " + error.toString()
                                  });
                                });
                              }
                            });
                          },
                          children: /*#__PURE__*/_jsx(TrashFill, {
                            size: 24
                          })
                        })]
                      })
                    })]
                  }, ic.id);
                })
              })]
            }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: newCompanyVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter une entreprise",
      onClose: function onClose() {
        setNewCompanyVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewCompany, {
        handler: function handler() {
          setDataChanged(true);
          setNewCompanyVisible(false);
        }
      })
    }), selectedCompany && /*#__PURE__*/_jsx(Drawer, {
      open: showEdit,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Modifier une entreprise",
      onClose: function onClose() {
        setShowEdit(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(EditCompany, {
        company: selectedCompany,
        handler: function handler() {
          setDataChanged(true);
          setShowEdit(false);
          notification.success({
            message: "Ok!",
            description: "Opération réussie !"
          });
        }
      })
    })]
  });
};
export default Companies;